import axios from "axios";
import { API_URL } from "../../config";
import { NotificationManager } from "react-notifications";
import unauthService from "../unauth";
import { getCookie } from "../../function";

const getRefundService = {
  fetchRefundRequests: async ({ status, page, limit, journalIds }) => {
    try {
      const token = getCookie("token");
      const response = await axios.get(`${API_URL}/refund`, {
        params: {
          page,
          limit,
          status,
          journalIds,
        },
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
          Authorization: getCookie("token"),
        },
      });

      console.log("Full API Response:", response.data);

      const parsedData = JSON.parse(response.data);
      console.log("Parsed Data:", parsedData);
      const result = JSON.parse(parsedData.body);

      console.log("Data:", result);

      // Assuming the new response structure is: { success: true, message: "Success", data: { data: [], totalItems: N, totalPages: M, currentPage: C, perPage: P } }
      if (result.data && result.success) {
        return {
          data: result.data.data,
          total: result.data.totalItems,
          totalPages: result.data.totalPages,
          perPage: result.data.perPage,
        };
      } else {
        throw new Error(
          response.data.message || "Failed to fetch refund requests"
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        unauthService();
      }
      console.error("Error fetching refund requests:", error);
      NotificationManager.error(
        "An error occurred while fetching refund requests."
      );
      return {
        data: [],
        total: 0,
        lastEvaluatedKey: null,
      };
    }
  },

  updateRefundStatus: async ({ id, action, adminRemark }) => {
    try {
      const response = await axios.put(
        `${API_URL}/refundStatus`,
        {
          adminRemark,
        },
        {
          params: {
            id,
            action,
          },
          headers: {
            Authorization: getCookie("token"),
            "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
          },
        }
      );
      console.log("API Call Params:", { id, action, adminRemark });
      console.log(response);
      const data = response.data;
      const parsedData = JSON.parse(data);
      console.log("parsedData", parsedData);
      const result = JSON.parse(parsedData.body);

      console.log("datatatat", result);

      if (result.success) {
        NotificationManager.success(
          result.data.message || "Refund status updated successfully"
        );
        return result;
      } else {
        throw new Error(
          result.data.message || "Failed to update refund status"
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        unauthService();
      }
      console.error("Error updating refund status:", error);
      NotificationManager.error(
        "An error occurred while updating refund status."
      );
      return null;
    }
  },

  updateRefundProcess: async ({ id, body }) => {
    try {
      const response = await fetch(`${API_URL}/refund?id=${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: getCookie("token"),
          "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      const parsedData = JSON.parse(data);
      const result = JSON.parse(parsedData.body);
      console.log("parsedData", result);
      return result;
    } catch (error) {
      console.error("Error updating refund process:", error);
      throw error;
    }
  },

  uploadToS3: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: formData,
      });

      const data = await response.json();
      return data.key;
    } catch (error) {
      console.error("Error uploading to S3:", error);
      throw error;
    }
  },
};

export default getRefundService;
